import { processNodeAndPermissions } from "../../../helper/com-helper";
import {
  Config,
  Demand,
  Home,
  Inventory,
  Order,
  Reports,
  Setting,
} from "../../../assets/svg-icons";
import { IBP } from "../IBP";

// SIP is available to everyone who has IBP access
const IBP_PERMISSIONS = [...IBP.permissions];

const SIP_OBJECT = {
  name: "SIP",
  route: "/sip/workspace",
  permissions: [],
  // keep the post-login landing page on the existing modules
  excludeFromLanding: true,
  child: {
    "My workspace": {
      name: "My workspace",
      shortName: "Workspace",
      route: "/sip/workspace",
      icon: Home,
      sipKey: "home",
      permissions: IBP_PERMISSIONS,
    },
    Orders: {
      name: "Orders",
      shortName: "Orders",
      route: "/sip/orders",
      icon: Order,
      sipKey: "orders",
      permissions: IBP_PERMISSIONS,
    },
    Operations: {
      name: "Operations",
      shortName: "Operations",
      route: null,
      icon: Config,
      permissions: [],
      child: {
        Procurement: {
          name: "Procurement",
          route: "/sip/procurement",
          sipKey: "suppliers",
          permissions: IBP_PERMISSIONS,
        },
        Production: {
          name: "Production",
          route: "/sip/production",
          sipKey: "prod",
          permissions: IBP_PERMISSIONS,
        },
        Logistics: {
          name: "Logistics",
          route: "/sip/logistics",
          sipKey: "dispatch",
          permissions: IBP_PERMISSIONS,
        },
        Inventory: {
          name: "Inventory",
          route: "/sip/inventory",
          sipKey: "inv",
          permissions: IBP_PERMISSIONS,
        },
      },
    },
    Manage: {
      name: "Manage",
      shortName: "Manage",
      route: null,
      icon: Setting,
      permissions: [],
      child: {
        "Risk & Actions": {
          name: "Risk & Actions",
          route: "/sip/risk-actions",
          sipKey: "risk",
          permissions: IBP_PERMISSIONS,
        },
        "Govern & Admin": {
          name: "Govern & Admin",
          route: "/sip/govern-admin",
          sipKey: "govern",
          permissions: IBP_PERMISSIONS,
        },
      },
    },
  },
  // vendor portal pages: routed here, shown in the menu only for the Vendor persona
  extraRoutes: [
    { route: "/sip/vendor/prs", permissions: IBP_PERMISSIONS },
    { route: "/sip/vendor/pos", permissions: IBP_PERMISSIONS },
    { route: "/sip/vendor/grn", permissions: IBP_PERMISSIONS },
    { route: "/sip/vendor/outlook", permissions: IBP_PERMISSIONS },
    { route: "/sip/vendor/scorecard", permissions: IBP_PERMISSIONS },
    { route: "/sip/vendor/orders", permissions: IBP_PERMISSIONS },
    { route: "/sip/vendor/history", permissions: IBP_PERMISSIONS },
  ],
};

processNodeAndPermissions(SIP_OBJECT);
export const SIP = SIP_OBJECT;

// Vendor persona's menu (prototype "Vendor portal" rail)
const VENDOR_MENU = {
  Home: { name: "Home", shortName: "Home", route: "/sip/workspace", icon: Home, permissions: IBP_PERMISSIONS },
  "Orders & deliveries": { name: "Orders & deliveries", shortName: "Orders", route: "/sip/vendor/orders", icon: Order, permissions: IBP_PERMISSIONS },
  "Requirement outlook": { name: "Requirement outlook", shortName: "Outlook", route: "/sip/vendor/outlook", icon: Demand, permissions: IBP_PERMISSIONS },
  Scorecard: { name: "Scorecard", shortName: "Scorecard", route: "/sip/vendor/scorecard", icon: Reports, permissions: IBP_PERMISSIONS },
};

// Must match ACCESS[persona].rail in the SNP app (rp-pp-frontend src/pages/SIP/data/personas.js)
const ALL = ["home", "orders", "suppliers", "prod", "dispatch", "inv", "risk", "govern"];
export const SIP_RAILS = {
  store: ["home", "orders", "inv", "govern"],
  site: ["home", "orders", "suppliers", "prod", "inv", "risk", "govern"],
  logistics: ["home", "orders", "dispatch", "inv", "govern"],
  l1: ALL,
  l2: ALL,
  admin: ALL,
};

// SIP left-menu children for a persona: drops items outside its rail and empty groups
export const sipMenuFor = (persona) => {
  if (persona === "vendor") return VENDOR_MENU;
  const rail = SIP_RAILS[persona] || ALL;
  const out = {};
  Object.entries(SIP_OBJECT.child).forEach(([key, node]) => {
    if (node.child) {
      const kids = Object.fromEntries(
        Object.entries(node.child).filter(([, c]) => rail.includes(c.sipKey))
      );
      if (Object.keys(kids).length) out[key] = { ...node, child: kids };
    } else if (rail.includes(node.sipKey)) {
      out[key] = node;
    }
  });
  return out;
};
